import {
  FormControl,
  FormHelperText,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Box,
} from '@chakra-ui/react'
import React from 'react'
import { FormLabel } from './FormLabel'
import { Input, InputProps } from './Input'

export interface LabeledInputProps extends InputProps {
  label?: string
  size?: 'sm' | 'md'
  helperText?: string
  errorMessage?: string
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
  charCounter?: number
}

export const LabeledInput = ({
  isDisabled = false,
  isInvalid,
  isRequired,
  label,
  placeholder,
  size = 'md',
  helperText,
  errorMessage,
  iconLeft,
  iconRight,
  charCounter,
  children,
  isReadOnly,
  ...baseProps
}: LabeledInputProps) => {
  const iconSize = size === 'sm' ? '8' : '10'
  return (
    <FormControl
      isRequired={isRequired}
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
    >
      {label && (
        <FormLabel
          fontWeight={isRequired ? 'semibold' : 'regular'}
          color={isInvalid ? 'red.500' : 'black'}
        >
          {label}
        </FormLabel>
      )}
      <InputGroup>
        {iconLeft && (
          <InputLeftElement
            color="gray.500"
            opacity={isDisabled ? 0.4 : 1}
            boxSize={iconSize}
            pointerEvents="none"
            width="32px"
          >
            <Box>{iconLeft}</Box>
          </InputLeftElement>
        )}
        {charCounter && (
          <Box
            as="span"
            sx={{ fontSize: 'var(--chakra-fontSizes-sm)' }}
            color={
              String(baseProps.value).length > charCounter
                ? 'red.500'
                : 'gray.500'
            }
            position="absolute"
            bottom="110%"
            right="0%"
          >
            {String(baseProps.value).length}/{charCounter}
          </Box>
        )}
        <Input
          placeholder={placeholder}
          isInvalid={isInvalid}
          size={size}
          {...(iconLeft && { paddingLeft: '8' })}
          {...(iconRight && { paddingRight: '8' })}
          {...baseProps}
        />
        {children}
        {iconRight && (
          <InputRightElement
            color="gray.500"
            opacity={isDisabled ? 0.4 : 1}
            boxSize={iconSize}
            pointerEvents="none"
            width="32px"
          >
            <Box>{iconRight}</Box>
          </InputRightElement>
        )}
      </InputGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  )
}
